export const getListFAQ = () => {
  return [
    {
      id: 1,
      question:
        "Mengapa saya harus memasukkan NIK terlebih dahulu sebelum mengisi data dan mengunggah foto selfie?",
      answers: [
        {
          id: 1,
          label:
            "NIK (Nomor Induk Kependudukan) digunakan untuk verifikasi identitas pelamar dan memastikan bahwa data yang dimasukkan valid serta tidak ada duplikasi dalam sistem.",
        },
      ],
    },
    {
      id: 2,
      question:
        "Apakah data saya aman jika saya memasukkan NIK ke dalam sistem?",
      answers: [
        {
          id: 1,
          label:
            "Ya, data Anda kami jamin kerahasiaannya sesuai dengan kebijakan privasi perusahaan dan tidak akan disalahgunakan.",
        },
      ],
    },
    {
      id: 3,
      question: "Saya tidak menerima OTP?",
      answers: [
        {
          id: 1,
          label:
            "Saat mendaftarkan akun, pastikan nomor Whatsapp yang Anda masukkan benar. Untuk memastikan nomor Whatsapp Anda terdaftar, lakukan verifikasi pada tombol action yang tersedia.",
        },
      ],
    },
    {
      id: 4,
      question: "Apakah saya bisa melamar pekerjaan pada posisi yang sama?",
      answers: [
        {
          id: 1,
          label: "Tidak bisa.",
        },
      ],
    },
    {
      id: 5,
      question:
        "Bagaimana cara saya mengonfirmasikan kehadiran pada undangan interview?",
      answers: [
        {
          id: 1,
          label:
            "Anda dapat memberikan konfirmasi kehadiran melalui metode yang disebutkan dalam undangan interview. Klik pada action button “Ya, saya bisa hadir” pada halaman undangan interview yang Anda terima.",
        },
      ],
    },
    {
      id: 6,
      question: "Bagaimana proses melamar pekerjaan di aplikasi ini?",
      answers: [
        {
          id: 1,
          label:
            "Buka halaman pendaftaran atau platform rekrutmen yang disediakan.",
        },
        {
          id: 2,
          label: "Masukkan NIK Anda pada kolom yang tersedia.",
        },
        {
          id: 3,
          label:
            "Setelah NIK diverifikasi, Anda dapat melanjutkan ke langkah berikutnya, yaitu mengisi data pribadi dan mengunggah foto selfie sesuai dengan instruksi.",
        },
      ],
    },
    {
      id: 7,
      question:
        "Apa yang harus saya lakukan jika mengalami kendala saat mengisi data atau mengunggah foto?",
      answers: [
        {
          id: 1,
          label:
            "Periksa koneksi internet Anda dan pastikan file foto tidak melebihi batas ukuran yang ditentukan.",
        },
        {
          id: 2,
          label: "Jika masalah berlanjut, gunakan perangkat atau browser lain.",
        },
        {
          id: 3,
          label:
            "Jika masih mengalami kendala, hubungi tim rekrutmen untuk mendapatkan bantuan lebih lanjut.",
        },
      ],
    },
    {
      id: 8,
      question:
        "Bagaimana cara memilih lokasi kerja jika lokasi yang tersedia lebih dari satu?",
      answers: [
        {
          id: 1,
          label:
            "Jika lokasi job posting lebih dari satu, pilih lokasi penempatan yang sesuai dengan kebutuhan Anda.",
        },
      ],
    },
    {
      id: 9,
      question: "Informasi gaji pada job posting",
      answers: [
        {
          id: 1,
          label:
            "Range gaji yang ditampilkan pada informasi job posting merupakan angka perkiraan, untuk angka gaji yang pasti akan dilakukan pada tahap offering.",
        },
      ],
    },
    {
      id: 10,
      question:
        "Saya tidak bisa melamar pekerjaan lain karna dalam status Hold?",
      answers: [
        {
          id: 1,
          label:
            "Jika Anda melamar pekerjaan lain sementara masih dalam proses kontrak dari lamaran sebelumnya, Anda tidak dapat melanjutkan proses tersebut dan akan diminta untuk menyelesaikan proses kontrak yang sedang berlangsung.",
        },
      ],
    },
    {
      id: 11,
      question:
        "Saya ingin melamar kerja, tapi usia saya baru 18 tahun? Apakah boleh?",
      answers: [
        {
          id: 1,
          label:
            "Maaf, usia minimum pelamar adalah 18 tahun. Jika usia Anda masih di bawah 18 tahun, lamaran tidak dapat kami proses.",
        },
      ],
    },
    {
      id: 12,
      question:
        "Apakah saya boleh menggunakan foto dari galeri atau harus mengambil foto baru?",
      answers: [
        {
          id: 1,
          label:
            "Kami sarankan untuk mengambil foto baru agar sesuai dengan instruksi. Namun, jika foto dari galeri memenuhi semua ketentuan yang diminta, Anda bisa menggunakannya.",
        },
      ],
    },
    {
      id: 13,
      question: "Mengapa saya harus mengunggah foto selfie?",
      answers: [
        {
          id: 1,
          label:
            "Foto selfie digunakan untuk verifikasi identitas dan memastikan bahwa data pelamar sesuai dengan dokumen yang diunggah.",
        },
      ],
    },
    {
      id: 14,
      question: "Kapan saya harus mengonfirmasikan kehadiran?",
      answers: [
        {
          id: 1,
          label:
            "Segera lakukan konfirmasi kehadiran setelah Anda menerima undangan interview, atau paling lambat sebelum batas waktu yang ditentukan dalam undangan.",
        },
      ],
    },
    {
      id: 15,
      question:
        "Bagaimana jika saya tidak bisa hadir interview pada jadwal yang telah ditentukan?",
      answers: [
        {
          id: 1,
          label:
            "Jika tidak bisa hadir, segera beritahu tim rekrutmen melalui email atau kontak yang tersedia. Anda bisa menyampaikan alasan dengan sopan dan menanyakan kemungkinan untuk menjadwalkan ulang.",
        },
      ],
    },
    {
      id: 16,
      question: "Apa yang terjadi jika saya tidak konfirmasi kehadiran?",
      answers: [
        {
          id: 1,
          label:
            "Perekrut akan menganggap Anda tidak tertarik dengan posisi tersebut dan tidak melanjutkan proses lamaran Anda.",
        },
      ],
    },
    {
      id: 17,
      question:
        "Bagaimana jika saya sudah konfirmasi kehadiran, namun mendadak tidak bisa hadir?",
      answers: [
        {
          id: 1,
          label:
            "Jika ada keadaan darurat, segera hubungi perekrut dan sampaikan permohonan maaf serta alasan Anda. Jika memungkinkan, tanyakan apakah ada kesempatan untuk menjadwalkan ulang.",
        },
      ],
    },
    {
      id: 18,
      question:
        "Apakah saya masih bisa mengikuti proses seleksi jika tidak menghadiri interview?",
      answers: [
        {
          id: 1,
          label:
            "Tidak bisa, Anda dianggap mundur dan proses lamaran tidak dapat dilanjutkan.",
        },
      ],
    },
  ];
};
